import { getTelnyxA2pRegistration } from 'api/generated/api/telnyx-a2p-registration';
import { referenceDataSwrOptions } from 'api/swrConfig';

import { useApiSWR } from './useApiSWR';

const { telnyxA2pRegistrationDeadlineStatusEndpoint } =
  getTelnyxA2pRegistration();

export const SMS_REGISTRATION_DEADLINE_SWR_KEY = 'sms-registration-deadline';

/**
 * Org SMS registration deadline state. Shared by the app-wide banner and the
 * add-candidates gate; SWR dedupes them into one request per org.
 */
export const useSmsRegistrationDeadline = (orgId: string | null) => {
  const { data, error, isLoading, mutate } = useApiSWR(
    orgId ? [SMS_REGISTRATION_DEADLINE_SWR_KEY, orgId] : null,
    () => telnyxA2pRegistrationDeadlineStatusEndpoint(),
    {
      ...referenceDataSwrOptions,
      // Lives in the persistent Layout; revalidate so the banner clears after
      // registration is submitted without a full reload.
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    // Only populated after a successful fetch, so nothing flashes on load or error.
    deadline: !isLoading && !error ? (data ?? null) : null,
    mutate,
  };
};
